module.exports = __webpack_public_path__ + "img/pin-over-map.fa2c54ec.svg";